import React, { useState, useContext, useEffect } from "react";

import IntlMessages from "../../../../util/IntlMessages";
import "./FormDetails.less";
import { Modal, Input, Button } from "../../../../components/BP2Components";
import { FormBuilderContext } from "../FormBuilderContext";

import { Icon_Edit } from "../../../BP2Components/Icons/icons";
import { downloadJson } from "../../../../util/generateAndDownloadJSON";

const FormDetails = ({ fields }) => {
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [title, setTitle] = useState("");
   const [description, setDescription] = useState("");

   const { previewMode, setData, data } = useContext(FormBuilderContext);
   const showModal = () => {
      setIsModalOpen(true);
   };

   const handleOk = () => {
      setIsModalOpen(false);

      setData({
         type: "change",
         value: {
            ...data,
            name: title,
            description,
         },
      });
   };

   const handleCancel = () => {
      setIsModalOpen(false);
   };

   useEffect(() => {
      setTitle(data.name);
   }, [data.name]);

   useEffect(() => {
      setDescription(data.description);
   }, [data.description]);
   return (
      <>
         <div className="form-builder-details">
            <div className="form-builder-details-content">
               <div className="title">
                  <strong>
                     <IntlMessages id="modal.formName" />:
                  </strong>{" "}
                  {`${title} (${data.id})`}
               </div>
               <div className="description">{description}</div>
            </div>
            <div className="form-builder-details-action">
               {!previewMode && (
                  <button className="form-builder-details-open" onClick={showModal}>
                     <Icon_Edit />
                  </button>
               )}
               <Button
                  buttonType="primary"
                  onClick={() => downloadJson(fields, title)}
                  disabled={!data.id}
               >
                  <IntlMessages id="json.downloadJSON" />
               </Button>
            </div>
         </div>
         <Modal title="Szczegóły" isOpen={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <div className="form-builder-details-modal">
               <div>
                  <label>
                     <IntlMessages id="modal.formName" />
                  </label>
                  <Input defaultValue={title} onChange={(e) => setTitle(e.target.value)} />
               </div>
            </div>
         </Modal>
      </>
   );
};

export default FormDetails;
